import { fromJS } from 'immutable';
export var SET_ENV_CFG = 'env-cfg/SET_ENV_CFG';
export var setEnvCfg = function setEnvCfg(data) {
  return {
    type: SET_ENV_CFG,
    data: data
  };
};
export default function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_ENV_CFG:
      {
        return fromJS(_.merge(state.toJS(), action.data));
      }

    default:
      return state;
  }
}